import observable from '@riotjs/observable'

function CategoryLoader() {
  observable(this)

  this.handler = (type) => {
    switch (type) {
      case 'root':
        return 'didLoadRootCategories'
      case 'root_and_brand':
        return 'didLoadRootAndBrandCategories'
      case 'brand':
        return 'didLoadBrandCategories'
      case 'model':
        return 'didLoadModelCategories'
      case 'model_with_references':
        return 'didLoadModelCategoriesWithReferences'
      default:
        return
    }
  }

  this.loadRootCategories = () => { _loadCategories('root') }
  this.loadRootAndBrandCategories = () => { _loadCategories('root_and_brand') }
  this.loadBrandCategories = (rootId) => { _loadCategories('brand', rootId) }
  this.loadModelCategories = (brandId) => { _loadCategories('model', brandId) }
  this.loadModelCategoriesWithReferences = (modelId) => { _loadCategories('model_with_references', modelId) }

  let _loadCategories = (type, categoryId) => {
    let headers = new Headers()
    if (__UDEDOKEI_ENV__ == 'staging') {
      headers.append('Authorization', __AUTH_KEY__);
    }
    headers.append('Content-Type', 'application/json');
    let url = '/categories/?format=json&type=' + type + (!!categoryId ? '&c=' + categoryId : '')
    fetch(url, {
      mode: 'same-origin',
      headers: headers
    }).then( (res) => res.json()).then( (res) => {
      let Category = require('models/category')
      var category = new Category(res, categoryId)
      this.trigger(this.handler(type), category)
    }).catch( (err) => {
      console.error(err)
    })
  }
}

export default CategoryLoader
